<template>
    <div>
        <el-card >
                <div class="title">
      <strong @click="$router.go(-1)" style="cursor: pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span >新增分类</span>
    </div>
    <div class="content">
    <el-form label-width="98px" :model="form" :rules="rules" ref="form">
    <el-form-item label="分类名称" required prop="categoryName">
 <el-input v-model="form.categoryName" style="width:200px" placeholder="请输入分类名称"></el-input>
  </el-form-item>
  <el-form-item label="排序" prop="seq" required>
  <el-input v-model.number="form.seq" style="width:200px"></el-input>
                </el-form-item>
             <el-form-item label="分类图" required>
            <el-upload
  class="avatar-uploader"
  :action="$uploadURL"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
  :before-upload="beforeAvatarUpload">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

                </el-form-item>

            </el-form>
    </div>
    <div class="foot">
    <div class="two">
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button @click="save">保存</el-button>
    </div>
    </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                imageUrl:'',
                form:{
                    merchantCode:localStorage.getItem('merchantCode'),
                    merchantName:localStorage.getItem('merchantName'),
                    categoryName:'',
                    seq:'',
                    logo:''
                },
            rules: {
          categoryName: [
            { required: true, message: '请输入分类名称', trigger: ['blur','change'] },
          ],
          seq:[
            {required:true,message:'请输入分类排序', trigger: ['blur','change'] },
            {type:'number',message:'请输入数字',trigger: ['blur','change']}
          ]
            }}
        },
        created(){
            if(this.$route.query.id!=null){
                this.edit()
            }
        },
        methods:{
         async  edit(){
            let data={
                merchantCode:localStorage.getItem('merchantCode'),
                merchantName:localStorage.getItem('merchantName'),
                id:this.$route.query.id
            }
     let res=await this.$http.post('merchantShangChengIndexProductCategory/queryOne',data)
       this.form.categoryName=res.data.data.categoryName
       this.form.seq=Number(res.data.data.seq)
       this.imageUrl=res.data.data.logo
       this.form.id=res.data.data.id
         },
           save(){
          if(this.imageUrl==''){
            this.$message.error('请上传分类图片')
            return
          }
         this.$refs['form'].validate((valid) => {
          if (valid) {
            this.form.logo=this.imageUrl
     this.$http.post('/merchantShangChengIndexProductCategory/save',this.form).then(res=>{
        if(res.data.code==200){
            this.$message({
                type:"success",
                message:'保存成功'
            })
            this.$router.push('/merchantShangChengIndexProductCategory')
        }else{
            this.$message.error(res.data.message)
        }
     })

          } else {
            console.log('error submit!!');
            return false;
          }
        });

            },
            handleAvatarSuccess(res){
                this.imageUrl=res.data.url
            },
           beforeAvatarUpload(){
            console.log('===')
           }
        }
    }
</script>

<style lang="scss" scoped>
  .title {
    padding: 6px 20px;
    height: 36px;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
    i,
    span {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .content{
    margin-top: 10px;
  }
  /deep/.el-card{
    padding-top: 0;
  }
   .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }
  .avatar {
    width: 130px;
    height: 130px;
    display: block;
  }
  /deep/ .el-upload{
    border: 1px dashed #DCDFE6;
  }
  /deep/ .el-form-item__label::after{
    content: ':';
    padding: 2px;
  }
  /deep/ .el-card__body{
    height: calc(100vh - 118px);
    position: relative;
  }
  .foot{
    position: absolute;
    bottom: 30px;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    .two{
        margin-right: 40px;
    }
  }
</style>